import { Target, mixActions } from "../store/MixReducer";
import { useAppDispatch, useAppSelector } from "../../../store";
import { TargetProps, useItemLayout } from "../screens/MixScreen";
import { ColorPicker } from "./ColorPicker";
import { GradientButton } from "../../../components";
import React from "react";
import { ViewStyle } from "react-native";
import { styles } from "../mixStyles";

export interface ButtonGenerateProps {
  style?: ViewStyle;
}

export const ButtonGenerate = ({ style }: ButtonGenerateProps) => {
  const dispatch = useAppDispatch();
  const disabled = useAppSelector(
    (state) => state.mix.alice.hasMixed || state.mix.bob.hasMixed
  );
  const item = useItemLayout();

  return (
    <GradientButton
      style={[item, styles.button]}
      outlined
      title={"Generator"}
      disabled={disabled}
      onPress={() => dispatch(mixActions.generate())}
    />
  );
};

export const ButtonRestart = () => {
  const dispatch = useAppDispatch();
  const mix = useAppSelector((state) => state.mix);
  const item = useItemLayout();

  return (
    <GradientButton
      style={[item, styles.button]}
      outlined
      disabled={!mix.alice.hasStarted && !mix.bob.hasStarted}
      title={"Neustart"}
      onPress={() => {
        dispatch(mixActions.reset());
        dispatch(mixActions.generate());
      }}
    />
  );
};

export interface PickerInterface {
  target: Target;
  disabled?: boolean;
}

export const Picker = ({ target, disabled }: PickerInterface) => {
  const dispatch = useAppDispatch();
  disabled ??= useAppSelector((state) => state.mix[target].hasMixed); // only set when disabled null | undefined
  const item = useItemLayout();

  return (
    <ColorPicker
      style={[item, styles.button]}
      disabled={disabled}
      target={target}
      onChange={(color: string) => dispatch(mixActions.pick({ target, color }))}
    />
  );
};

export const ButtonMix = ({ target }: TargetProps) => {
  const dispatch = useAppDispatch();
  const disabled = useAppSelector(
    (state) => !state.mix[target].hasPicked || state.mix[target].hasMixed
  );
  const item = useItemLayout();

  return (
    <GradientButton
      style={[item, styles.button]}
      outlined
      title={"Mischen"}
      disabled={disabled}
      onPress={() => {
        dispatch(mixActions.mix(target));
      }}
    />
  );
};

export const ButtonSend = ({ target }: TargetProps) => {
  const other = target === "bob" ? "alice" : "bob";
  const dispatch = useAppDispatch();
  const disabled = useAppSelector(
    (state) =>
      !state.mix[target].hasMixed ||
      state.mix[target].hasSent ||
      !state.mix[other].hasStarted
  );
  const item = useItemLayout();

  return (
    <GradientButton
      style={[item, styles.button]}
      outlined
      title={"Senden"}
      disabled={disabled}
      onPress={() => {
        dispatch(mixActions.send(target));
      }}
    />
  );
};

export const ButtonFinish = ({ target }: TargetProps) => {
  const dispatch = useAppDispatch();
  const disabled = useAppSelector(
    (state) =>
      !state.mix[target].hasPicked ||
      !state.mix[target].hasReceived ||
      state.mix[target].hasResult
  );
  const item = useItemLayout();

  return (
    <GradientButton
      style={[item, styles.button]}
      outlined
      title={"Mischen"}
      disabled={disabled}
      onPress={() => {
        dispatch(mixActions.finish(target));
      }}
    />
  );
};
